// NPM Imports
import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Tooltip } from "../../revvComponents";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import ToolPaneListItem from "./ToolPaneListItem";

// Actions Imports
import { QuotationActions, ToolbarActions } from "../../actions";
import { updateDocumentClickedComponentID } from "../../actions/DocumentActions";

// Services Imports

// Internal Imports
import { TOOLPANE, DOCUMENTS } from "../../constants";
import { buttonClickEvent } from "../../gtm/gtmutils";
import { GlobalUtils } from "../../utils";

// Destructuring
const { TOOLPANE_OPTIONS, TOOLPANE_OPTIONS_FREE } = TOOLPANE;
const { updateToolPaneData } = QuotationActions;
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { updateAddComponentinToolbarAction } = ToolbarActions;
const { checkFreePlan } = GlobalUtils;

export default function ToolPaneList({
  foundSignatureBlockStatus,
  isOpen,
  mode,
  page,
  templateStatus,
  view,
}) {
  // mapStateToProps
  const addComponentType = useSelector(
    state => state.ToolPaneStore.addComponentType,
  );
  const billingData = useSelector(state => state.CommonStore.billingInfo);
  // mapDispatchToProps
  const dispatch = useDispatch();

  const _onChangeView = (newView, gtmAction) => {
    // this is to click gtm action click
    if (view !== newView) {
      buttonClickEvent(gtmAction);
    }
    if (foundSignatureBlockStatus) {
      if (isOpen) {
        dispatch(updateDocumentClickedComponentID(null, true, null));
      }
      dispatch(updateAddComponentinToolbarAction("Signature"));
    }
    if (view === newView && isOpen === true) {
      dispatch(updateToolPaneData(false, ""));
    } else {
      dispatch(updateToolPaneData(true, newView));
      if (addComponentType === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
        dispatch(updateAddComponentinToolbarAction(null));
      }
    }
  };
  let toolPaneOptions = [];
  if (checkFreePlan(billingData.plan_type)) {
    toolPaneOptions = TOOLPANE_OPTIONS_FREE[page];
  } else {
    toolPaneOptions = TOOLPANE_OPTIONS[page];
  }
  return toolPaneOptions.map(option => (
    <ToolPaneListItem
      key={option.title}
      onChangeView={_onChangeView}
      foundSignatureBlockStatus={foundSignatureBlockStatus}
      isOpen={isOpen}
      view={view}
      templateStatus={templateStatus}
      mode={mode}
      option={option}
    />
  ));
}
